import Vue from 'vue'
import Toasted from 'vue-toasted'
import router from '../router'

const toasterOptions = {
  position: 'top-right',
  iconPack: 'fontawesome',
  duration: 3000,
  icon: 'check-circle-o',
  type: 'success'
}

Vue.use(Toasted, toasterOptions)
Vue.use(Toasted, { router })



// WEBPACK FOOTER //
// ./src/plugins/toastedConfig.js